import "@/App.css";
import DesignOne from "./designs/DesignOne";

function App() {
  return (
    <div className="App">
      <DesignOne />
    </div>
  );
}

export default App;
